import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// Firebase configuration object
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCi39ETFzKyhQ62F0pQ0AN0NyQZSvSE4uk",
  authDomain: "myeparking.firebaseapp.com",
  projectId: "myeparking",
  storageBucket: "myeparking.firebasestorage.app",
  messagingSenderId: "540983018679",
  appId: "1:540983018679:web:c1376d1ddc8d534f727932",
  measurementId: "G-TRP1RXE0Z9"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app); // For authentication
export const db = getFirestore(app); // For Firestore database
